var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.289062,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F49E00",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2891 23H8.28906V21.4444H9.08906V9.77778C9.08906 9.5715 9.17335 9.37367 9.32338 9.22781C9.47341 9.08194 9.67689 9 9.88906 9H21.0891C21.3012 9 21.5047 9.08194 21.6547 9.22781C21.8048 9.37367 21.8891 9.5715 21.8891 9.77778V13.6667H23.4891V21.4444H24.2891V23ZM20.2891 21.4444H21.8891V15.2222H17.0891V21.4444H18.6891V16.7778H20.2891V21.4444ZM20.2891 13.6667V10.5556H10.6891V21.4444H15.4891V13.6667H20.2891ZM12.2891 15.2222H13.8891V16.7778H12.2891V15.2222ZM12.2891 18.3333H13.8891V19.8889H12.2891V18.3333ZM12.2891 12.1111H13.8891V13.6667H12.2891V12.1111Z",
    fill: "#F49E00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2891,
    cy: 6,
    r: 4,
    fill: "#F49E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCompanyIcon);
export default __webpack_public_path__ + "static/media/new-company-icon.14b6170ab4cf29b4b4670f83d66e70e1.svg";
export { ForwardRef as ReactComponent };